module.exports = __webpack_public_path__ + "static/media/logo1_ai copy436_alpha.fe99bb2c.png";